<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-row>
      <v-spacer></v-spacer>
      <!--      <v-col cols="3" v-if="canUpdateMillingChargeOnSettlement">-->
      <v-col cols="3" v-if="canCreateMillingCharge">
        <v-btn
          color="#7BC243"
          @click="openCreateDialog"
          class="white--text cataloguebtn"
          >Create Miller Charge
        </v-btn>
      </v-col>
    </v-row>
    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Miller Charges
                </span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
              <v-spacer> </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search"> </v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
			<template v-slot:item.documentUpload.fileName="{ item }">
                <a
                  href="#"
                  class="primary--text"
                  @click.prevent="downloadContractPDF(item)"
                >
                  {{ item.documentUpload.fileName }}
                </a>
              </template>
              <template v-slot:item.actions="{ item }">

                <v-menu
                  offset-y
                  v-if="
                   (canUpdateMillingCharge &&
                      item['status']['statusName'] ==
                        'PENDING_CHECKER_APPROVAL' &&(
                          organisationType.toUpperCase() === 'MILLER' ||
                        organisationType.toUpperCase() === 'FARMER_SOCIETY' || organisationType.toUpperCase() === 'ESTATE')
                      ) ||
                    (item['status']['statusName'] == 'PENDING_NCE_APPROVAL' &&
                      organisationType.toUpperCase() === 'GOVERMENT') ||
                    (item['status']['statusName'] == 'PENDING_COOP_APPROVAL' &&
                      organisationType.toUpperCase() === 'COOP BANK')
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      style="color: red"
                      class="actions"
                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="approveRejectChargeShowDialog(item, 1)"
                      >
                        Approve
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title
                        style="cursor: pointer"
                        @click="approveRejectChargeShowDialog(item, 0)"
                      >
                        Reject
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="createMillerChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Create Milling Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs4>
                      <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        v-model="grower"
                        :items="filteredGrowers"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Grower"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error grower-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        label="Miller"
                        item-text="name"
                        item-value="value"
                        v-model="miller"
                        :items="filteredMillers"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Miller"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error miller-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Milling Charge(Per Ton)"
                        min="1"
                        type="number"
                        v-model="milling_charge_per_ton"
                      ></v-text-field>
                      <label
                        class="custom-form-error milling-charge-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Parchment Transport(Per Bag)"
                        min="1"
                        type="number"
                        v-model="parchment_transport_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error parchment-transport-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Drying Parchment Charge(Per Ton)"
                        min="1"
                        type="number"
                        v-model="drying_parchment_charge_per_ton"
                      ></v-text-field>
                      <label
                        class="custom-form-error drying-parchment-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Clean Coffee Storage Charge(Per 60kg)"
                        min="1"
                        type="number"
                        v-model="clean_coffee_storage_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error clean-storage-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Clean Coffee HandSorting Charge(Per 60kg)"
                        min="1"
                        type="number"
                        v-model="clean_coffee_hadsorting_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error clean-handsorting-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Clean Coffee Transport Charge(Per 60kg)"
                        min="1"
                        type="number"
                        v-model="clean_coffee_transport_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error clean-transport-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Handling Parchment Charge (Per 60Kg)"
                        min="1"
                        type="number"
                        v-model="handling_parchment_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error parchment-handling-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Handling Clean Coffee Charge (Per 60Kg)"
                        min="1"
                        type="number"
                        v-model="handling_clean_coffee_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error clean-handling-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Color Sorting Clean Coffee Charge (Per 60Kg)"
                        min="1"
                        type="number"
                        v-model="colorsorting_clean_coffee_charge_per_bag"
                      ></v-text-field>
                      <label
                        class="custom-form-error color-sorting-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Export Bag Charge"
                        min="1"
                        type="number"
                        v-model="export_bag_charge"
                      ></v-text-field>
                      <label
                        class="custom-form-error export-bag-charge-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <!--                    <v-flex xs4>
                      <v-text-field label="Estate Cured Charge" min="1" type="number" v-model="estate_cured_charge"></v-text-field>
                      <label class="custom-form-error estate-cured-charge-error" for="contract"></label>
                    </v-flex>-->
                    <v-flex xs4>
                      <label for="contractstartdate">Contract Start Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_start_date"
                      />
                      <p
                        class="custom-form-error contract-start-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex xs4>
                      <label for="contractenddate">Contract End Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_end_date"
                      />
                      <p
                        class="custom-form-error contract-end-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex id="fileupload" xs4>
                      <label for="contract">Contract </label>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        required
                      />
                      <p
                        class="custom-form-error contract-file-error"
                        for="contract"
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="createMillerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="createMillerCharge"
                >Submit</v-btn
              >
              <v-progress-circular
                v-show="createMillerLoader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="editMillerChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Update Milling Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs4>
                      <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        v-model="grower"
                        :items="this.growers"
                        variant="solo-filled"
                      ></v-select>
                      <label
                        class="custom-form-error grower-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                        label="Warehouse"
                        item-text="name"
                        item-value="value"
                        v-model="warehouse"
                        :items="this.warehouses"
                        variant="solo-filled"
                      ></v-select>
                      <label
                        class="custom-form-error warehouse-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Handling Charge (Per Kg)"
                        min="1"
                        type="number"
                        v-model="handling_charge"
                      ></v-text-field>
                      <label
                        class="custom-form-error handling-charge-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Milling Charge (Per Kg)"
                        min="1"
                        type="number"
                        v-model="milling_charge"
                      ></v-text-field>
                      <label
                        class="custom-form-error milling-charge-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Export Bag Charge"
                        min="1"
                        type="number"
                        v-model="export_bag_charge"
                      ></v-text-field>
                      <label
                        class="custom-form-error export-bag-charge-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <!--                    <v-flex xs4>
                      <v-text-field label="Estate Cured Charge" min="1" type="number" v-model="estate_cured_charge"></v-text-field>
                      <label class="custom-form-error estate-cured-charge-edit-error" for="contract"></label>
                    </v-flex>-->
                    <v-flex xs4>
                      <label for="contractstartdate">Contract Start Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="selectedContractStartDate"
                      />
                      <p
                        class="custom-form-error contract-start-date-edit-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex xs4>
                      <label for="contractenddate">Contract End Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="selectedContractEndDate"
                      />
                      <p
                        class="custom-form-error contract-end-date-edit-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex id="fileupload" xs4>
                      <label for="contract">Contract </label>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        required
                      />
                      <p
                        class="custom-form-error contract-file-error"
                        for="contract"
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="editMillerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="updateMillerCharge"
                >Submit</v-btn
              >
              <v-progress-circular
                v-show="updateMillerLoader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog
        v-model="approveRejectMillerChargeDialog"
        persistent
        max-width="500"
      >
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Miller Charge</v-card-title
            >
            <v-card-text v-if="approveStatus === 1"
              >Do you want to approve the charge?
            </v-card-text>
            <v-card-text v-if="approveStatus === 0"
              >Do you want to reject the charge?
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="approveRejectMillerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="approveStatus === 1"
                color="secondary"
                @click="approveMillerCharge"
                >Approve</v-btn
              >
              <v-btn
                v-if="approveStatus === 0"
                color="secondary"
                @click="approveMillerCharge"
                >Reject</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import config from "../../../config";
import store from "../../../store";
import http from "../../../http";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "catalogueupload",
  data: function () {
    return {
      gradeDisabled: true,
      defaultGrower: {
        name: "Grower1",
        value: "Grower1",
      },
      defaultWarehouse: {
        name: "Warehouse1",
        value: "Warehouse1",
      },
      defaultSelectedGrade: {
        name: "None",
        value: "None",
      },
      borrowerType: [
        {
          name: "FCS",
          value: "FCS",
        },
        {
          name: "FCS FARMER",
          value: "FCS_FARMER",
        },
        {
          name: "ESTATE FARMER",
          value: "ESTATE_FARMER",
        },
      ],
      coffeeType: [
        {
          name: "CHERRY",
          value: "CHERRY",
        },
        {
          name: "PARCHMENT",
          value: "PARCHMENT",
        },
        {
          name: "CLEAN COFFEE",
          value: "CLEAN COFFEE",
        },
      ],
      gradeType: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeEdit: [],
      gradeTypeCherry: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeParchment: [
        {
          name: "P1",
          value: "P1",
        },
        {
          name: "P2",
          value: "P2",
        },
        {
          name: "P3",
          value: "P3",
        },
      ],
      gradeTypeCleanCoffee: [
        {
          name: "AA",
          value: "AA",
        },
        {
          name: "BB",
          value: "BB",
        },
        {
          name: "C",
          value: "C",
        },
      ],
      rates: [],
      editFarmerType: {},
      editCoffeeType: {},
      editGrade: {},
      editStatus: "",
      cherryRateTemp: { rate: 0, name: "hello" },
      millerObject: {},
      headers: [
        { text: "Grower", value: "grower.organisationName" },
        { text: "GrowerCode", value: "grower.organisationCode" },
        { text: "Miller", value: "miller.organisationName" },
        { text: "Milling Charge", value: "millingCharge" },
        {
          text: "Parchment Transport Charge",
          value: "parchmentTransportCharge",
        },
        { text: "Clean Handsorting Charge", value: "cleanHandSortingCharge" },
        { text: "Parchment Drying Charge", value: "parchmentDryingCharge" },
        { text: "Clean Storage Charge", value: "cleanStorageCharge" },
        { text: "Clean Transport Charge", value: "cleanTransportCharge" },
        { text: "Parchment Handling Charge", value: "parchmentHandlingCharge" },
        { text: "Clean Handling Charge", value: "cleanHandlingCharge" },
        { text: "Colorsorting Charge", value: "colorSortingCharge" },
        { text: "Export Bag Charge", value: "exportBagCharge" },
        { text: "Contract", value: "documentUpload.fileName" },
        { text: "Status", value: "status.statusName" },
		{ text: "Actions", value: "actions", sortable: false },
      ],
      borrower_type: "",
      coffee_type: "",
      grade: "",
      rate_amount: "",
      rate_amount_edit: "",
      milling_id: "",
      approveStatus: 0,
      approveRejectDialogTitle: "Do you want to approve the charge?",
      approveRejectDialogButton: "Approve",
      valid: true,
      message: "",
      snackbar: false,
      snackbarColor: "",
      file: "",
      files: [],
      pagination: { sortBy: "id", descending: true },
      search: "",
      searchInput: "",
      selectedGrower: null,
      permissions: [],
      previewLoading: false,
      approveloading: false,
      declineloading: false,
      createMillerLoader: false,
      updateMillerLoader: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      page: 1,
      confirmDialog: false,
      confirmFile: {},
      confirmMessage: "",
      action: "",
      rateLimitDialog: false,
      createMillerChargeDialog: false,
      editMillerChargeDialog: false,
      approveRejectMillerChargeDialog: false,
      userID: 0,
      warehouse: "",
      warehouses: [],
      miller: "",
      millers: [],
      growers: [],
      grower: "",
      handling_charge: "",
      milling_charge_per_ton: "",
      parchment_transport_per_bag: "",
      drying_parchment_charge_per_ton: "",
      clean_coffee_storage_charge_per_bag: "",
      clean_coffee_hadsorting_charge_per_bag: "",
      clean_coffee_transport_charge_per_bag: "",
      handling_parchment_charge_per_bag: "",
      handling_clean_coffee_charge_per_bag: "",
      colorsorting_clean_coffee_charge_per_bag: "",
      milling_charge: "",
      export_bag_charge: "",
      estate_cured_charge: "",
      contract_start_date: "",
      contract_end_date: "",
      organisationType: "",
      selectedContractStartDate: new Date().toISOString().split("T")[0],
      selectedContractEndDate: new Date().toISOString().split("T")[0],
      organisationId: 0,
    };
  },
  mounted() {
    this.getMillingCharges();
    this.getWarehouse();
    this.getFCS();
    this.getMillers();
    this.permissions = store.state.user.roleId.permissions;
  },
  watch: {
    files() {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        1,
        this.numberOfItemsPerPage
      );
      this.numberOfLinks = Math.ceil(
        this.files.length / this.numberOfItemsPerPage
      );
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        val,
        this.numberOfItemsPerPage
      );
    },
  },
  computed: {
    ...mapState({ user: (state) => state.user }),
    canUploadFarmers: function () {
      return this.hasPerm("CAN_UPLOAD_FARMERS");
    },
    canCreateMillingCharge: function () {
      return this.hasPerm("CAN_CREATE_MILLER_CHARGE");
    },
    canUpdateMillingCharge: function () {
      return this.hasPerm("CAN_UPDATE_MILLER_CHARGE");
    },
    canApproveCatalogue: function () {
      return this.hasPerm("CAN_APPROVE_CATALOGUE");
    },
    filteredList: function () {
      if (this.search === "") {
        return this.paginatedFiles;
      } else {
        return this.files.filter((file) => {
          return file.fileName
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
    },
    userId: function () {
      if (this.user) {
        console.log("user - ", this.user);
        console.log("user2 - ", this.user.organisation.id);
        this.organisationType = this.user.organisation.organisationType.name;
        this.organisationId = this.user.organisation.id;
        this.userID = this.user.id;
        return this.user.id;
      }
      return 0;
    },
    filteredGrowers() {
      return this.growers.filter((grower) =>
        grower.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
    filteredMillers() {
      return this.millers.filter((miller) =>
        miller.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
  },
  methods: {
	downloadContractPDF(file) {
      // Base64 encoded string of a small PDF file
      const base64String = file.documentUpload.file;

      // This function converts a base64 string to a Blob
      function base64ToBlob(base64, type) {
        const binary = atob(base64.replace(/\s/g, ""));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }
        return new Blob([view], { type: type });
      }

      const blob = base64ToBlob(base64String, "application/pdf");
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.setAttribute(
        "download",
        file.documentUpload.fileName + ".pdf"
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    },
    format_date(value) {
      if (value) {
        // return moment(String(value)).format('yyyy-MM-dd')
        return moment(new Date(value)).format("yyyy-MM-dd");
      }
    },
    getMillers: function () {
      if (this.user.organisation.organisationType.name === "MILLER") {
        // Use data from user.organisation
        this.millers.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      } else {
        const url = config.serverURI + "/organization/getMillers";

        axios
          .post(url)

          .then((response) => {
            response.data.forEach((x) => {
              console.log("Millers", x.millerId);
              // this.millers.push({ name: x.name, value: x.millerId });
              // this.millersEdit.push({ name: x.name, value: x.name });
              this.millers.push({
                name: x.name + " " + " -" + " " + x.millerCode,
                value: x.millerCode,
              });
            });

            console.log("Millers", response.data);
            // this.millers = response.data
          })
          .catch((error) => {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: error.response.data
                ? error.response.data.message
                : "Error ocurred",
            });
          });
        return this.organisations;
      }
    },
    getWarehouse: function () {
      const url = config.serverURI + "/organization/getWarehouse";
      axios
        .post(url)
        .then((response) => {
          this.warehouses = response.data;
          console.log("warehouse --- ", this.warehouses);
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    getFCS() {
      if (this.user.organisation.organisationType.name === "FARMER_SOCIETY") {
        // Use data from user.organisation
        this.growers.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      }
      const url = config.serverURI + "/organization/get-fcs";
      axios
        .get(url)
        .then((response) => {
          console.log("FCS>>>>", response.data);
          // this.growers = response.data
          response.data.forEach((x) => {
            this.growers.push({
              name: x.organisationName + " " + " -" + " " + x.organisationCode,
              value: x.organisationCode,
            });
          });
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.message,
          });
        });
    },
    // getFCS () {
    //   const url = config.serverURI + '/organization/get-fcs'
    //   axios.get(url)
    //     .then(response => {
    //       // this.growers = response.data
    //       response.data.forEach(x => {
    //         this.growers.push({ name: x.organisationName, value: x.organisationName })
    //       })
    //     })
    //     .catch(error => {
    //       this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
    //     })
    // },
    canBeApproved(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    canBeDeclined(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    paginationMethod(items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1;
      const from = pageNumber * limitPerPage;
      let to = (pageNumber + 1) * limitPerPage;
      if (to >= items.length) {
        to = items.length;
      }
      return items.slice(from, to);
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    openCreateDialog() {
      this.createMillerChargeDialog = true;
    },
    createMillerCharge() {
      const grower = this.grower.value;
      const miller = this.miller.value;
      const milling_charge = this.milling_charge_per_ton;
      const parchment_transport = this.parchment_transport_per_bag;
      const drying_parchment = this.drying_parchment_charge_per_ton;
      const clean_storage = this.clean_coffee_storage_charge_per_bag;
      const clean_handsorting = this.clean_coffee_hadsorting_charge_per_bag;
      const clean_transport_charge = this.clean_coffee_transport_charge_per_bag;
      const parchment_handling = this.handling_parchment_charge_per_bag;
      const clean_handling = this.handling_clean_coffee_charge_per_bag;
      const color_sorting = this.colorsorting_clean_coffee_charge_per_bag;
      const exportBagCharge = this.export_bag_charge;
      // const estateCuredCharge = this.estate_cured_charge
      const contractStartDate = this.contract_start_date;
      const contractEndDate = this.contract_end_date;

      console.log(
        grower,
        miller,
        milling_charge,
        parchment_transport,
        drying_parchment,
        clean_storage,
        clean_handsorting,
        clean_transport_charge,
        parchment_handling,
        clean_handling,
        color_sorting,
        exportBagCharge,
        contractStartDate,
        contractEndDate
      );

      $(".custom-form-error").css("display", "none");

      if (
        grower === "" ||
        grower === "undefined" ||
        typeof grower === "undefined"
      ) {
        $(".grower-error").css("display", "inline");
        $(".grower-error").text("Please select grower");
        return;
      }

      if (
        miller === "" ||
        miller === "undefined" ||
        typeof miller === "undefined"
      ) {
        $(".miller-error").css("display", "inline");
        $(".miller-error").text("Please select miller");
        return;
      }

      if (milling_charge === "") {
        $(".milling-charge-error").css("display", "inline");
        $(".milling-charge-error").text("Please enter milling charge");
        return;
      }

      if (parchment_transport === "") {
        $(".parchment-transport-error").css("display", "inline");
        $(".parchment-transport-error").text(
          "Please enter parchment transport charge"
        );
        return;
      }
      if (clean_handsorting === "") {
        $(".clean-handsorting-error").css("display", "inline");
        $(".clean-handsorting-error").text(
          "Please enter clean handsorting charge"
        );
        return;
      }
      if (drying_parchment === "") {
        $(".drying-parchment-error").css("display", "inline");
        $(".drying-parchment-error").text(
          "Please enter parchment drying charge"
        );
        return;
      }
      if (clean_storage === "") {
        $(".clean-storage-error").css("display", "inline");
        $(".clean-storage-error").text("Please enter clean storage charge");
        return;
      }
      if (clean_transport_charge === "") {
        $(".clean-transport-error").css("display", "inline");
        $(".clean-transport-error").text("Please enter clean transport charge");
        return;
      }
      if (parchment_handling === "") {
        $(".parchment-handling-error").css("display", "inline");
        $(".parchment-handling-error").text(
          "Please enter parchment handling charge"
        );
        return;
      }
      if (clean_handling === "") {
        $(".clean-handling-error").css("display", "inline");
        $(".clean-handling-error").text("Please enter clean handling charge");
        return;
      }
      if (color_sorting === "") {
        $(".color-sorting-error").css("display", "inline");
        $(".color-sorting-error").text("Please enter color sorting charge");
        return;
      }

      if (exportBagCharge === "") {
        $(".export-bag-charge-error").css("display", "inline");
        $(".export-bag-charge-error").text("Please enter export bag charge");
        return;
      }

      /*  if (estateCuredCharge === '') {
        $('.estate-cured-charge-error').css('display', 'inline')
        $('.estate-cured-charge-error').text('Please enter estate cured charge')
        return
      } */

      if (contractStartDate === "") {
        $(".contract-start-date-error").css("display", "block");
        $(".contract-start-date-error").text(
          "Please select contract start date"
        );
        return;
      }

      if (contractEndDate === "") {
        $(".contract-end-date-error").css("display", "block");
        $(".contract-end-date-error").text("Please select contract end date");
        return;
      }

      if (this.file.length === 0) {
        $(".contract-file-error").css("display", "block");
        $(".contract-file-error").text("Please upload file");
        return;
      }

      if (new Date(contractStartDate) > new Date(contractEndDate)) {
        $(".contract-end-date-error").css("display", "block");
        $(".contract-end-date-error").text(
          "Contract start date is greater than end date"
        );
        return;
      }

      this.createMillerLoader = true;
      const urlUpload = config.serverURI + "/miller/upload";

      const formData = new FormData();
      formData.append("file", this.file);

      axios({ url: urlUpload, method: "POST", data: formData })
        .then((response) => {
          if (response.data.error !== false) {
            this.createMillerLoader = false;
            $(".contract-file-error").css("display", "block");
            $(".contract-file-error").text(
              "Something went wrong, please try again"
            );
            return;
          }
          console.log("Response>>", response);
          const fileId = response.data.message;
          console.log("fileId ## ", fileId);
          var url =
            config.serverURI +
            "/miller/create?userId=" +
            this.userID +
            "&fileId=" +
            fileId +
            "&grower=" +
            grower +
            "&miller=" +
            miller +
            "&millingCharge=" +
            milling_charge +
            "&parchmentTransport=" +
            parchment_transport +
            "&cleanHandSorting=" +
            clean_handsorting +
            "&dryingParchment=" +
            drying_parchment +
            "&cleanStorage=" +
            clean_storage +
            "&cleanTransportCharge=" +
            clean_transport_charge +
            "&parchmentHandling=" +
            parchment_handling +
            "&cleanHandling=" +
            clean_handling +
            "&colorSorting=" +
            color_sorting +
            "&exportBagCharge=" +
            exportBagCharge +
            "&contractStartDate=" +
            contractStartDate +
            "&contractEndDate=" +
            contractEndDate;

          axios
            .post(url, {})
            .then((response) => {
              var data = response.data;
              var checkError = data.error;
              this.createMillerChargeDialog = false;
              console.log("checkError ", checkError);

              this.createMillerLoader = false;
              if (checkError !== undefined) {
                this.message = data.message;
                this.snackbar = true;
                this.snackbarColor = "error";
                return;
              }

              this.handling_charge = "";
              this.milling_charge = "";
              this.export_bag_charge = "";
              this.estate_cured_charge = "";
              this.contract_start_date = "";
              this.contract_end_date = "";

              this.message = "Successfully added miller charge";
              this.snackbar = true;
              this.snackbarColor = "primary";
              this.getMillingCharges();
            })
            .catch((error) => {
              this.createMillerLoader = false;
              this.message = "Something went wrong, please try again";
              this.snackbar = true;
              this.snackbarColor = "error";
            });
        })
        .catch((error) => {
          this.createMillerLoader = false;
          $(".contract-file-error").css("display", "block");
          $(".contract-file-error").text(error.response.data.message);
        })
        .finally(() => {
          this.showProgressBar = false;
        });
    },
    approveRejectChargeShowDialog(item, status) {
      console.log(item);
      console.log(status);
      this.approveStatus = status;
      this.milling_id = item.id;
      this.approveRejectMillerChargeDialog = true;
    },
    editMillerCharge(item) {
      console.log("ITMxx -> ", item);
      $(".custom-form-error").css("display", "none");
      this.editMillerChargeDialog = true;
      this.millerObject = item;
      this.grower = item.grower.organisationName;
      this.warehouse = item.warehouse.name;
      this.handling_charge = item.handlingCharge;
      this.milling_charge = item.millingCharge;
      this.export_bag_charge = item.exportBagCharge;
      // this.estate_cured_charge = item.estateCuredCharge
      this.contract_start_date = item.contractStartDate;
      this.contract_end_date = item.contractEndDate;
      this.editStatus = item.status.statusName;
      this.rate_amount_edit = item.rate;
      this.milling_id = item.id;

      const startDate = new Date(this.contract_start_date);
      const endDate = new Date(this.contract_end_date);
      const parseStartDate = new Date(
        startDate.getTime() + Math.abs(startDate.getTimezoneOffset() * 60000)
      )
        .toISOString()
        .split("T")[0];
      const parseEndDate = new Date(
        endDate.getTime() + Math.abs(endDate.getTimezoneOffset() * 60000)
      )
        .toISOString()
        .split("T")[0];

      this.selectedContractStartDate = parseStartDate;
      this.selectedContractEndDate = parseEndDate;
    },
    getMillingCharges() {
      console.log("orgTYPE ", this.organisationType.toUpperCase());
      let url = "/miller/getAllForApproval";
      //   "/miller/findAllOrderByOrganisationId?organisationId=" +
      //   this.organisationId;

      // if (this.organisationType.toUpperCase() !== "MILLER") {
      //   url = "/miller/getAllForApproval";
      // }
      /* if (this.organisationType.toUpperCase() === 'GOVERMENT'){
          url = '/miller/findAllByStatus?status=PENDING_NCE_APPROVAL&organisationId=' + this.organisationId
      }

      if (this.organisationType.toUpperCase() === 'COOP BANK'){
        url = '/miller/findAllByStatus?status=PENDING_COOP_APPROVAL&organisationId=' + this.organisationId
      } */

      http
        .get(config.serverURI + url)
        .then((response) => {
          this.rates = response.data;
          console.log("RR -> ", response.data);


        })
        .catch((error) => {
          console.log("error", error);
          this.$store.dispatch(
            "alert/displayAlert",
            {
              snackbar: true,
              color: "error",
              message: error.response
                ? error.response.data.message
                : "Error ocurred",
            },
            { root: true }
          );
        });
    },
    millerChargeUpdateReq(url) {
      axios
        .put(url, {})
        .then((response) => {
          var data = response.data;
          var checkError = data.error;
          this.editMillerChargeDialog = false;
          console.log("checkError ", checkError);

          this.approveloading = false;
          this.updateMillerLoader = false;
          if (checkError !== undefined) {
            this.message = data.message;
            this.snackbar = true;
            this.snackbarColor = "error";
            return;
          }

          this.handling_charge = "";
          this.milling_charge = "";
          this.export_bag_charge = "";
          this.estate_cured_charge = "";
          this.contract_start_date = "";
          this.contract_end_date = "";

          this.message = "Successfully updated miller charge";
          this.snackbar = true;
          this.snackbarColor = "primary";
          this.getMillingCharges();
        })
        .catch((error) => {
          this.approveloading = false;
          this.rateLimitDialog = false;
          this.updateMillerLoader = false;
          this.message = "Something went wrong, please try again";
          this.snackbar = true;
          this.snackbarColor = "error";
        });
    },
    updateMillerCharge() {
      const grower = this.grower;
      const warehouse = this.warehouse;
      const handlingCharge = this.handling_charge;
      const millingCharge = this.milling_charge;
      const exportBagCharge = this.export_bag_charge;
      // const estateCuredCharge = this.estate_cured_charge
      const contractStartDate = this.contract_start_date;
      const contractEndDate = this.contract_end_date;

      console.log(
        grower,
        warehouse,
        handlingCharge,
        millingCharge,
        exportBagCharge,
        contractStartDate,
        contractEndDate
      );

      $(".custom-form-error").css("display", "none");

      if (grower === "") {
        $(".grower-edit-error").css("display", "inline");
        $(".grower-edit-error").text("Please select grower");
        return;
      }

      if (warehouse === "") {
        $(".warehouse-edit-error").css("display", "inline");
        $(".warehouse-edit-error").text("Please select warehouse");
        return;
      }

      if (handlingCharge === "") {
        $(".handling-charge-edit-error").css("display", "inline");
        $(".handling-charge-edit-error").text("Please enter handling charge");
        return;
      }

      if (millingCharge === "") {
        $(".milling-charge-edit-error").css("display", "inline");
        $(".milling-charge-edit-error").text("Please enter milling charge");
        return;
      }

      if (exportBagCharge === "") {
        $(".export-bag-charge-edit-error").css("display", "inline");
        $(".export-bag-charge-edit-error").text(
          "Please enter export bag charge"
        );
        return;
      }

      if (
        new Date(this.selectedContractStartDate) >
        new Date(this.selectedContractEndDate)
      ) {
        $(".contract-end-date-edit-error").css("display", "block");
        $(".contract-end-date-edit-error").text(
          "Contract start date is greater than end date"
        );
        return;
      }

      $(".custom-form-error").css("display", "none");

      if (
        grower !== "" ||
        warehouse !== "" ||
        handlingCharge !== "" ||
        millingCharge !== "" ||
        exportBagCharge !== "" ||
        contractStartDate !== "" ||
        contractEndDate !== ""
      ) {
        this.updateMillerLoader = true;
        if (this.file.length === 0) {
          var url =
            config.serverURI +
            "/miller/update?userId=" +
            this.userID +
            "&millingId=" +
            this.milling_id +
            "&grower=" +
            grower +
            "&warehouse=" +
            warehouse +
            "&handlingCharge=" +
            handlingCharge +
            "&millingCharge=" +
            millingCharge +
            "&exportBagCharge=" +
            exportBagCharge +
            "&estateCuredCharge=0&contractStartDate=" +
            this.selectedContractStartDate +
            "&contractEndDate=" +
            this.selectedContractEndDate +
            "&fileId=0";
          this.millerChargeUpdateReq(url);
        } else {
          const urlUpload = config.serverURI + "/miller/upload";

          const formData = new FormData();
          formData.append("file", this.file);

          axios({
            url: urlUpload,
            method: "POST",
            data: formData,
          })
            .then((response) => {
              if (response.data.error !== false) {
                this.updateMillerLoader = false;
                $(".contract-file-error").css("display", "block");
                $(".contract-file-error").text(
                  "Something went wrong, please try again"
                );
                return;
              }
              const fileId = response.data.message;
              console.log("fileId ## ", fileId);
              var url =
                config.serverURI +
                "/miller/update?userId=" +
                this.userID +
                "&millingId=" +
                this.milling_id +
                "&grower=" +
                grower +
                "&warehouse=" +
                warehouse +
                "&handlingCharge=" +
                handlingCharge +
                "&millingCharge=" +
                millingCharge +
                "&exportBagCharge=" +
                exportBagCharge +
                "&estateCuredCharge=0&contractStartDate=" +
                this.selectedContractStartDate +
                "&contractEndDate=" +
                this.selectedContractEndDate +
                "&fileId=" +
                fileId;
              this.millerChargeUpdateReq(url);
            })
            .catch((error) => {
              $(".contract-file-error").css("display", "block");
              $(".contract-file-error").text(error.response.data.message);
              this.updateMillerLoader = false;
            })
            .finally(() => {
              this.showProgressBar = false;
            });
        }
      } else {
        this.message = "Please enter all fields";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
    approveMillerCharge() {
      const millerId = this.milling_id;
      if (millerId !== "") {
        var url =
          config.serverURI +
          "/miller/approve?userId=" +
          this.userID +
          "&millerId=" +
          millerId +
          "&status=" +
          this.approveStatus +
          "&organisationType=" +
          this.organisationType;
        axios
          .put(url, {})
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then((response) => {
            var data = response.data;
            var checkError = data.error;
            this.approveRejectMillerChargeDialog = false;
            console.log("checkError ", checkError);
            if (checkError !== undefined) {
              this.message = data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              return;
            }
            let msg = "Successfully approved miller charge";
            if (this.approveStatus === 0) {
              msg = "Successfully rejected miller charge";
            }
            this.snackbar = true;
            this.snackbarColor = "primary";
            this.getMillingCharges();
          })
          .catch((error) => {
            this.approveRejectMillerChargeDialog = false;
            this.message = "Something went wrong, please try again";
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      } else {
        this.message = "Please enter all checkoffSettlementDetails";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
  },
};
</script>
<style>
.custom-form-error {
  display: none;
  color: red;
}

.main-layout {
  margin-top: 15px;
}

.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn {
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}

.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.thead {
  background-color: #00513b !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733d29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733d29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #f2d0a7;
  color: #733d29;
}

.pagination > li.active > .page-link {
  background: #00513b;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col {
  border: 1px solid brown;
}
</style>
